import { useEffect, useId } from "react";

import { useDirtyFormContext } from "./DirtyFormContext";

/**
 * Registers the form's dirty state with the global DirtyFormContext.
 * When dirty is true, navigation away from the current page will be blocked
 * and the user will be prompted to confirm discarding unsaved changes.
 *
 * Usage: call this hook inside a form component, passing formik.dirty.
 */
export function useDirtyForm(dirty: boolean): void {
  const id = useId();
  const { registerDirtyForm, unregisterDirtyForm } = useDirtyFormContext();

  useEffect(() => {
    if (dirty) {
      registerDirtyForm(id);
    } else {
      unregisterDirtyForm(id);
    }

    return () => {
      unregisterDirtyForm(id);
    };
  }, [dirty, id, registerDirtyForm, unregisterDirtyForm]);
}
